export interface ColumnConfig {
  id: string;
  label: string;
  key: string;
  sortable: boolean;
  visible: boolean;
  width: string;
  required?: boolean;
}

export interface TablePreferences {
  columns: ColumnConfig[];
  version: string;
}

export const DEFAULT_COLUMNS: ColumnConfig[] = [
  {
    id: 'startDate',
    label: 'Start Date',
    key: 'startDate',
    sortable: true,
    visible: true,
    width: 'w-32',
  },
  {
    id: 'name',
    label: 'Project name',
    key: 'name',
    sortable: true,
    visible: true,
    width: 'w-36',
    required: true,
  },
  {
    id: 'buildingType',
    label: 'Building type',
    key: 'buildingType',
    sortable: true,
    visible: true,
    width: 'w-32',
  },
  {
    id: 'gfa',
    label: 'Area (m²)',
    key: 'gfa',
    sortable: true,
    visible: true,
    width: 'w-24',
  },
  {
    id: 'impactPerGfa',
    label: 'A1-A3 (kg CO₂e/m²)',
    key: 'impactPerGfa',
    sortable: true,
    visible: true,
    width: 'w-36',
  },
  {
    id: 'totalImpact',
    label: 'A1-A3 (tons)',
    key: 'totalImpact',
    sortable: true,
    visible: true,
    width: 'w-36',
  },
  {
    id: 'a4PerGfa',
    label: 'A4 (kg CO₂e/m²)',
    key: 'a4PerGfa',
    sortable: true,
    visible: false,
    width: 'w-36',
  },
  {
    id: 'a4TotalImpact',
    label: 'A4 (tons)',
    key: 'a4TotalImpact',
    sortable: true,
    visible: false,
    width: 'w-36',
  },
  {
    id: 'a5PerGfa',
    label: 'A5 (kg CO₂e/m²)',
    key: 'a5PerGfa',
    sortable: true,
    visible: false,
    width: 'w-36',
  },
  {
    id: 'a5TotalImpact',
    label: 'A5 (tons)',
    key: 'a5TotalImpact',
    sortable: true,
    visible: false,
    width: 'w-36',
  },
  {
    id: 'budget',
    label: 'CO₂ budget',
    key: 'budget',
    sortable: false,
    visible: true,
    width: 'w-28',
  },
  {
    id: 'dataAccuracy',
    label: 'Data accuracy',
    key: 'dataAccuracy',
    sortable: true,
    visible: true,
    width: 'w-32',
  },
  // Circularity metrics - all non-selected by default
  {
    id: 'totalMaterialKg',
    label: 'Total Material (kg)',
    key: 'totalMaterialKg',
    sortable: true,
    visible: false,
    width: 'w-32',
  },
  // Inflow metrics
  {
    id: 'inflowReusedMaterialsKg',
    label: 'Inflow: Reused Materials (kg)',
    key: 'inflowReusedMaterialsKg',
    sortable: true,
    visible: false,
    width: 'w-40',
  },
  {
    id: 'inflowPreservedMaterialsKg',
    label: 'Inflow: Preserved Materials (kg)',
    key: 'inflowPreservedMaterialsKg',
    sortable: true,
    visible: false,
    width: 'w-40',
  },
  {
    id: 'inflowRecycledPreConsumerKg',
    label: 'Inflow: Recycled Pre-Consumer (kg)',
    key: 'inflowRecycledPreConsumerKg',
    sortable: true,
    visible: false,
    width: 'w-44',
  },
  {
    id: 'inflowRecycledPostConsumerKg',
    label: 'Inflow: Recycled Post-Consumer (kg)',
    key: 'inflowRecycledPostConsumerKg',
    sortable: true,
    visible: false,
    width: 'w-44',
  },
  {
    id: 'inflowBiomassMaterialsKg',
    label: 'Inflow: Biomass Materials (kg)',
    key: 'inflowBiomassMaterialsKg',
    sortable: true,
    visible: false,
    width: 'w-40',
  },
  {
    id: 'inflowTotalKgCO2eSaved',
    label: 'Inflow: CO₂e Saved (kg)',
    key: 'inflowTotalKgCO2eSaved',
    sortable: true,
    visible: false,
    width: 'w-36',
  },
  // Outflow metrics
  {
    id: 'outflowReusableMaterialsKg',
    label: 'Outflow: Reusable Materials (kg)',
    key: 'outflowReusableMaterialsKg',
    sortable: true,
    visible: false,
    width: 'w-40',
  },
  {
    id: 'outflowRecyclableMaterialsKg',
    label: 'Outflow: Recyclable Materials (kg)',
    key: 'outflowRecyclableMaterialsKg',
    sortable: true,
    visible: false,
    width: 'w-44',
  },
  {
    id: 'outflowDemolitionSystemsKg',
    label: 'Outflow: Demolition Systems (kg)',
    key: 'outflowDemolitionSystemsKg',
    sortable: true,
    visible: false,
    width: 'w-40',
  },
  {
    id: 'outflowInstallationSystemsKg',
    label: 'Outflow: Installation Systems (kg)',
    key: 'outflowInstallationSystemsKg',
    sortable: true,
    visible: false,
    width: 'w-44',
  },
  {
    id: 'actions',
    label: '',
    key: 'actions',
    sortable: false,
    visible: true,
    width: 'w-20',
    required: true,
  },
];

export const PREFERENCES_VERSION = '1.1.0';
